import Cookies from 'js-cookie'
import React from 'react'
import MobileNav from '../components/MobileNav'
import { useHistory } from 'react-router-dom'
function SideBbar(props) {

   console.log(props)
   let username = Cookies.get('username');

   const history = useHistory()
   const [loading, setLoading] = React.useState(false)
   function handleSelectionCity() {

      history.push('/')
   }
   function handleChangePass() {

      history.push('/changePassword')
   }
   function handlePress() {

      // if (city === null) {
      //     setAlert(true)
      //     return;
      // }
      //setLoading(true)
      //const cityData = cities.find(u => u.CityId == 1);
      // console.log("ffffff",cityData);
      //Cookies.set('city', JSON.stringify(cityData));
      //   getParams(1).then(data => {
      //     

      //   })
      //setLoading(false)
      history.push('/main')
   }
   function handleLogout() {
      Cookies.remove('username')
      Cookies.remove('city')
      history.push('/login')
   }
   return (
      <>
         <ul class="landbride-sidebar navbar-nav sidebar sidebar-dark accordion" id="accordionSidebar">
            <a class="sidebar-brand d-flex align-items-center justify-content-center"   >
               <div class="sidebar-brand-text "><img class="logoimg" src="../assets/img/LB-Icon-White.svg" alt=""></img></div>
            </a>
            <li class="nav-item accordionSidebar">
               <a class="nav-link" onClick={handleSelectionCity} href="javascript:void(0);">
                  <svg class={props.main} xmlns="http://www.w3.org/2000/svg" width="29" height="29" viewBox="40 151 29 29">
                     <path d="M54.5 151A14.516 14.516 0 0 0 40 165.5 14.516 14.516 0 0 0 54.5 180 14.516 14.516 0 0 0 69 165.5 14.517 14.517 0 0 0 54.5 151Zm-5.065 8.53h10.058c.563 1.646.89 3.363.97 5.117H48.466c.078-1.754.407-3.471.97-5.118Zm-.97 6.823h12a18.456 18.456 0 0 1-.975 5.118H49.44a18.394 18.394 0 0 1-.975-5.118Zm10.35-8.53h-8.703a19.276 19.276 0 0 1 3.361-5.066c.34-.026.68-.051 1.027-.051a11.74 11.74 0 0 1 .84.04 89.398 89.398 0 0 0 .112.008 19.32 19.32 0 0 1 3.364 5.07Zm-8.696 15.353h8.69a19.324 19.324 0 0 1-3.376 5.07c-.309.022-.62.048-.933.048-.341 0-.674-.026-1.006-.051a19.37 19.37 0 0 1-3.375-5.067Zm12.052-6.823h5.08a12.668 12.668 0 0 1-1.444 5.118h-4.51a20.068 20.068 0 0 0 .874-5.118Zm-.87-6.824h4.506a12.722 12.722 0 0 1 1.444 5.118h-5.08a20.062 20.062 0 0 0-.87-5.118Zm-19.552 6.824h5.01a20.068 20.068 0 0 0 .875 5.118h-4.44a12.668 12.668 0 0 1-1.445-5.118Zm5.01-1.706h-5.01a12.668 12.668 0 0 1 1.444-5.118h4.436a20.062 20.062 0 0 0-.87 5.118Zm13.93 8.53h4.022a12.824 12.824 0 0 1-6.678 4.61 20.772 20.772 0 0 0 2.656-4.61Zm4.022-15.353h-4.015a20.794 20.794 0 0 0-2.644-4.606 12.827 12.827 0 0 1 6.66 4.606Zm-20.424 15.352h3.952a20.716 20.716 0 0 0 2.64 4.587 12.81 12.81 0 0 1-6.592-4.587Zm3.947-15.352h-3.947a12.824 12.824 0 0 1 6.574-4.584 20.75 20.75 0 0 0-2.627 4.584Z" fill-rule="evenodd" data-name="world-svgrepo-com" />
                  </svg>
               </a>
            </li>
            <li class="nav-item accordionSidebar">
               <a class="nav-link" onClick={handlePress} href="javascript:void(0);">
                  <svg class={props.home} xmlns="http://www.w3.org/2000/svg" width="29" height="34.982" viewBox="40 207.518 29 34.982">
                     <path d="M43.764 227.129v1.464h4.09l2.977 13.907h1.497l-2.977-13.907h3.847V242.5H55.8v-13.907h3.847L56.671 242.5h1.496l2.977-13.907h4.09v-1.464h-21.47ZM40 222.569l1.708 2.434h25.584L69 222.57H40Zm10.482-6.512 1.179 2.359-5.53 1.382h16.737l-5.53-1.382 1.179-2.359h-8.035Zm3.285-8.54v7.076h1.464v-7.075h-1.464Z" fill-rule="evenodd" data-name="space-needle-svgrepo-com" />
                  </svg>
               </a>
            </li>

            <li class="nav-item bottom-fix accordionSidebar">
               <a class="nav-link" onClick={handleChangePass} href="javascript:void(0);">
                  <svg class={props.pass} xmlns="http://www.w3.org/2000/svg" width="29" height="29" viewBox="40 737 29 29">
                     <path d="m68.898 749.838-4.415-1.327a10.19 10.19 0 0 0-.809-1.96l2.182-4.055a14.772 14.772 0 0 0-2.354-2.354l-4.055 2.184a10.362 10.362 0 0 0-1.962-.809l-1.323-4.415A14.434 14.434 0 0 0 54.5 737c-.563 0-1.116.04-1.662.102l-1.323 4.415c-.688.203-1.346.474-1.962.81l-4.055-2.183a14.553 14.553 0 0 0-2.352 2.354l2.181 4.052a10.316 10.316 0 0 0-.808 1.961l-4.417 1.327A14.434 14.434 0 0 0 40 751.5a14.434 14.434 0 0 0 .102 1.662l4.415 1.323c.205.688.474 1.346.809 1.964l-2.182 4.053a14.633 14.633 0 0 0 2.354 2.354l4.055-2.182c.617.335 1.276.604 1.962.809l1.323 4.415A14.482 14.482 0 0 0 54.5 766a14.459 14.459 0 0 0 1.662-.102l1.323-4.415a10.316 10.316 0 0 0 1.962-.809l4.053 2.182a14.713 14.713 0 0 0 2.354-2.356l-2.18-4.053a10.316 10.316 0 0 0 .809-1.962l4.415-1.323A14.481 14.481 0 0 0 69 751.5a14.482 14.482 0 0 0-.102-1.662Zm-5.787 3.277-.262.884a8.438 8.438 0 0 1-.676 1.636l-.437.81.435.81 1.624 3.02a12.55 12.55 0 0 1-.522.522l-3.826-2.062-.81.436a8.7 8.7 0 0 1-1.638.676l-.884.263-.264.883-.988 3.296a13.1 13.1 0 0 1-.363.005 13.1 13.1 0 0 1-.363-.005l-.988-3.296-.264-.883-.884-.263a8.528 8.528 0 0 1-1.636-.676l-.81-.436-3.83 2.059a13.694 13.694 0 0 1-.522-.522l2.06-3.828-.436-.81a8.72 8.72 0 0 1-.676-1.638l-.26-.882-4.178-1.252a8.687 8.687 0 0 1-.007-.362 8.714 8.714 0 0 1 .007-.363l4.176-1.252.262-.884c.171-.575.398-1.126.676-1.636l.437-.81-2.061-3.83a15.012 15.012 0 0 1 .52-.522l3.833 2.064.812-.442a8.406 8.406 0 0 1 1.631-.674l.884-.262.264-.884.988-3.296a26.794 26.794 0 0 1 .365-.003c.12 0 .24.002.363.005l.988 3.296.264.883.884.263c.572.17 1.124.398 1.638.676l.81.435 3.828-2.061c.177.169.353.343.522.522l-1.626 3.02-.435.81.439.81a8.537 8.537 0 0 1 .674 1.632l.262.884.884.265 3.296.99a26.275 26.275 0 0 1 .003.364 8.714 8.714 0 0 1-.007.363l-4.176 1.252Zm-8.611-5.88a4.27 4.27 0 0 0-4.265 4.265 4.27 4.27 0 0 0 4.265 4.265 4.27 4.27 0 0 0 4.265-4.265 4.27 4.27 0 0 0-4.265-4.265Zm-2.559 4.265a2.562 2.562 0 0 0 2.559 2.559 2.562 2.562 0 0 0 2.559-2.559 2.562 2.562 0 0 0-2.559-2.559 2.562 2.562 0 0 0-2.559 2.559Z" fill-rule="evenodd" data-name="settings-svgrepo-com" />
                  </svg>
               </a>
            </li>
         </ul>
         <a class="sidebar-brand d-flex align-items-center justify-content-center dispnone" id="" >
            <div class="sidebar-brand-text mt-2 "><img class="logoimg" src="../assets/img/LB-Icon-White.svg" alt="" ></img></div>
         </a>
         <MobileNav props={props} />
         <nav class="navbar navbar-expand navbar-light topbar fixed-top bg-blue" style={{ minHeight: '80px' }}>
            {props.screen == 'Setting' ?
               (<>
                  <div class="input-group ">
                     <button class="btn btn-primary  returnDashboard" type="button" onClick={() => history.push("/main")}>
                        Return to Dashboard
                     </button>
                  </div>
               </>) : ""}
            {props.screen == 'Form' ?
               (<>

                  <button class="btn btn-primary  returnDashboard" type="button" onClick={() => history.push("/main")}>
                     Return to Dashboard
                  </button>
               </>) : ""}
            {props.screen == 'Main' ?
               (<>
                  <button class="btn btn-primary returnDashboard" type="button" onClick={() => history.push("/add-form")}>
                     New Report
                  </button>
               </>) : ""}

            {props.screen == 'View' ?
               (<>

                  <button class="btn btn-primary  returnDashboard" type="button" onClick={() => history.push("/main")}>
                     Return
                  </button>
                  <button class="btn btn-primary  EditAnalysis" type="button" onClick={() => history.push("/form/" + btoa(props.formId + "_" + username), {
                     form_id: btoa(props.formId + "_" + username),
                  })}>
                     Edit Analysis
                  </button>
               </>) : ""}

            <ul class="navbar-nav ml-auto" id="navProfile">

               <li class="nav-item dropdown no-arrow">
                  <a class="nav-link dropdown-toggle" href="#" id="userDropdown" role="button"
                     data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                     <span class="name mr-4 d-none d-lg-inline text-white small">Welcome, {Cookies.get('username') || "John Doe"}</span>
                     <img class="img-profile rounded-circle" style={{ width: "40px", height: "40px", borderRadius: "50%" }}
                        src={Cookies.get('Image')}></img>
                  </a>
                  <div class="dropdown-menu dropdown-menu-right shadow animated--grow-in"
                     aria-labelledby="userDropdown">

                     <a class="dropdown-item" onClick={handleLogout} href="javascript:void(0);">
                        <i class="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400"></i>
                        Sign Out
                     </a>
                  </div>
               </li>
            </ul>
         </nav>
      </>
   );
}
export default SideBbar